import { render, staticRenderFns } from "./RewardsCalculator.vue?vue&type=template&id=7ad30e26&"
import script from "./RewardsCalculator.vue?vue&type=script&lang=js&"
export * from "./RewardsCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports